import ChevronRight from '@mui/icons-material/ChevronRight';
import Box, { type BoxProps } from '@mui/material/Box';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import Typography, { type TypographyProps } from '@mui/material/Typography';

import { Loader } from '@openx/components-core/lib/Loader/Loader.tsx';

const RootBox = (props: BoxProps) => (
  <Box {...props} sx={{ alignItems: 'center', display: 'flex', justifyContent: 'flex-start', ...(props?.sx ?? {}) }} />
);

type ExpandCollapseIconProps = { expanded: boolean };
const EpxandCollapseIcon = ({ expanded, ...svgProps }: SvgIconProps & ExpandCollapseIconProps) => (
  <ChevronRight
    data-expandicon="expandRow"
    color="primary"
    data-test="expand-icon"
    {...svgProps}
    sx={{
      transform: expanded ? 'rotate(270deg)' : 'rotate(90deg)',

      ...(svgProps?.sx ?? {}),
    }}
  />
);

const NameTypography = (props: TypographyProps) => (
  <Typography
    variant="body1Bold"
    data-test="segment-name"
    {...props}
    sx={[
      {
        fontSize: '13px',
        lineHeight: '18px',
      },
      ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
    ]}
  />
);

export const NameCell = ({ segment, highlighter }) => {
  const { expanded, depth, description, name: segmentName, is_nav_only: isNavOnly, isFetching } = segment;

  const showDescription = !isNavOnly && description;

  const highlitedName = highlighter(segmentName);
  const highlitedDescription = highlighter(description);

  return (
    <RootBox sx={{ paddingLeft: depth * 4, paddingY: isNavOnly ? 2 : 1.5 }}>
      {isNavOnly && <EpxandCollapseIcon expanded={expanded} />}
      <Box
        data-test={!showDescription && 'taxonomy-name'}
        sx={{
          paddingLeft: 2,
          paddingRight: 1,
        }}
      >
        <NameTypography>{highlitedName}</NameTypography>
        {showDescription && (
          <Typography color={isNavOnly ? 'primary' : 'textSecondary'} variant="caption" data-test="segment-caption">
            {highlitedDescription}
          </Typography>
        )}
      </Box>
      {isFetching && <Loader noPadding size={18} />}
    </RootBox>
  );
};
